module.exports = __webpack_public_path__ + "assets/img/pdf.c035aca6.png";